module.exports = __webpack_public_path__ + "static/media/vintage09.b4f6ccc5.png";